import React from 'react'
import { Control, Controller, FieldErrors, UseFormRegister } from 'react-hook-form'
import { TextField } from '@material-ui/core'
import { t } from 'ttag'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import YumSelect from '../../../../components/YumSelect/YumSelect'
import { CompanyId, UserCompanyDto, UserId } from '../../../../services/api.types'
import { yuMuuvPublicCompanyId } from '../../../Settings/Settings'
import { FormData } from '../../ChallengeAdmin'

import { ReactComponent as OrganizerActiveIcon } from '../../../../assets/v3/icons/organizer-active.svg'

interface ChallengeStepOrganizerProps {
  control: Control<FormData>
  errors: FieldErrors<FormData>
  register: UseFormRegister<FormData>

  formStep: number
  userId: UserId
  companyId: CompanyId
  activityType: CustomTypeCategory
  managedCompanies: UserCompanyDto[]
  userCompanies: UserCompanyDto[]
  contractPeriod: any
}

export default function ChallengeStepOrganizer(props: ChallengeStepOrganizerProps) {
  const {
    control,
    register,
    errors,
    formStep,
    companyId,
    userId,
    activityType,
    managedCompanies,
    userCompanies,
    contractPeriod,
  } = props

  const userGoalsEnabled = userCompanies
    .filter(({ companyId }) => companyId != yuMuuvPublicCompanyId)
    .some((uc) => uc.userGoalsEnabled)

  const newCommunityDisabled = managedCompanies.filter(({ ownerUserId }) => ownerUserId === userId).length >= 3

  return (
    <>
      <Controller
        name="companyId"
        rules={{
          min: formStep === 4 && activityType === CustomTypeCategory.ALL ? 1 : undefined,
          max: formStep === 4 && activityType === CustomTypeCategory.ALL ? 1000 : undefined,
          required: formStep === 4 && activityType === CustomTypeCategory.ALL,
        }}
        control={control}
        render={({ field: { ref, ...otherField } }) => (
          // @ts-ignore
          <YumSelect label={t`Organizer`} startIcon={OrganizerActiveIcon} {...otherField}>
            {managedCompanies.map((userCompany, keyIndex) => (
              <option key={keyIndex} value={userCompany.companyId}>
                {userCompany.companyName}
              </option>
            ))}
            {userGoalsEnabled && (
              <option value="new" disabled={newCommunityDisabled}>
                + {t`Create new community`}
                {newCommunityDisabled ? ' (' + t`limit exceeded` + ')' : ''}
              </option>
            )}
          </YumSelect>
        )}
      />
      {companyId === 'new' && (
        <TextField
          style={{ margin: '12px 0 0 0', width: '100%' }}
          label={t`New community name`}
          {...register('newCommunityName', { required: formStep === 0 && companyId === 'new' })}
          margin="normal"
          error={!!errors.newCommunityName}
          variant="filled"
          InputProps={{
            disableUnderline: true,
          }}
          inputProps={{
            id: 'newCommunityName',
          }}
        />
      )}
      {contractPeriod && (
        <div style={{ marginTop: '10px', fontSize: '12px', textAlign: 'center' }}>{contractPeriod}</div>
      )}
    </>
  )
}
